import { ChannelDefinition } from '../types/registerClosure.types';

export const REGISTER_CHANNELS: ChannelDefinition[] = [
  { id: 'cash', label: 'Cobro en Efectivo', desc: 'Cuadre físico de billetes y monedas en el cajón portamonedas', isCash: true },
  { id: 'card', label: 'Pagos con Tarjeta', desc: 'Suma de cobros del día reportados por el datáfono o TPV comercial', isCash: false },
  { id: 'marcial_card', label: 'Tarjeta Marcial Pons', desc: 'Cobros abonados con la tarjeta de cuenta Marcial Pons', isCash: false },
  { id: 'gift_card', label: 'Tarjeta o Cheque Regalo', desc: 'Suma de vales y cheques regalo canjeados', isCash: false },
  { id: 'invoice', label: 'Contra Factura (Clientes)', desc: 'Facturación registrada para entidades gubernamentales o empresas', isCash: false }
];
